import React, { useState, useEffect } from "react";
import "./account.css";
import { fetchMasterlist, fetchCancelSubcriptionApi, fetchEditSubcriptionUserDetailApi, fetchSubscriptionLoginUserApi } from "../../api/api";
import SignupPopup from "../SignupPopup";
import {convertUTCToLocalFormatted} from "../../helper/index"
import { useNavigate } from "react-router-dom";

export default function Accounts({setToken}) {
  const storedLoginData = sessionStorage.getItem("loginData");
  const parsedLoginData = storedLoginData ? JSON.parse(storedLoginData) : {};

  const [loginData, setLoginData] = useState(parsedLoginData);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupPersonal, setShowPopupPersonal] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [countries, setCountries] = useState([]);
  const [fieldError, setFieldError] = useState("");
  const [cancelReason, setCancelReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [showPopupSignup, setShowPopupSignup] = useState(false);
  const [formData, setFormData] = useState({
    email: loginData.username || "",
    password: loginData.password || "",
  });
  const [formDataPersonal, setFormDataPersonal] = useState({
    firstname: loginData.firstname || "",
    country: loginData.country || "",
  });
  const [error, setError] = useState("");
  const [cancelMessage, setCancelMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();


  const handleCloseSignup = () => setShowPopupSignup(false);

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const response = await fetchMasterlist();
        if (response && Array.isArray(response.data.countrycodes)) {
          setCountries(response.data.countrycodes);
        } else {
          console.error("Invalid country response:", response);
        }
      } catch (err) {
        console.error("Error fetching countries:", err);
      }
    };
    loadCountries();
  }, []);

  // --- Login Popup Handlers ---
  const handleEditClick = () => setShowPopup(true);
  const handleClose = () => setShowPopup(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      setFieldError("Email is required.");
      return;
    }
    if (!emailRegex.test(formData.email)) {
      setFieldError("Please enter a valid email address.");
      return;
    }
    const updatedData = {
    ...loginData,
    username: formData.email, 
    password: formData.password
  };

  try {
    const response = await fetchEditSubcriptionUserDetailApi(updatedData);
    if (response.statuscode === 200 || response.success) {
      setLoginData(updatedData);
      sessionStorage.setItem("loginData", JSON.stringify(updatedData));
      setShowPopup(false);
    } else {
      setError("Failed to update user details:", response.message || response);
      // console.error("Failed to update user details:", response.message || response);
    }
  } catch (err) {
    console.error("Error updating user details:", err);
  }
  };

  // --- Personal Popup ---
  const handleEditClickPersonal = () => setShowPopupPersonal(true);
  const handleClosePersonal = () => setShowPopupPersonal(false);

  const handleChangePersonal = (e) => {
    const { name, value } = e.target;
    setFormDataPersonal((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitPersonal = async (e) => {
  e.preventDefault();
  const updatedData = {
    ...loginData,
    firstname: formDataPersonal.firstname,
    country: formDataPersonal.country,
  };

  try {
    const response = await fetchEditSubcriptionUserDetailApi(updatedData);
    if (response.statuscode === 200 || response.success) {
      setLoginData(updatedData);
      sessionStorage.setItem("loginData", JSON.stringify(updatedData));
      setShowPopupPersonal(false);
    } else {
      console.error("Failed to update user details:", response.message || response);
    }
  } catch (err) {
    console.error("Error updating user details:", err);
  }
  };


  // --- Cancel Subscription Popup ---

  const handleCancelClick = () => setShowCancelPopup(true);
  const handleCloseCancel = () => setShowCancelPopup(false);


  const handleCancelSubmit = async (e) => {
  e.preventDefault();
  const finalReason = cancelReason === "Other" ? otherReason : cancelReason;
  const data = {
    paypalsubscriptionid: loginData.paypalsubscriptionid,
    email: loginData.username,
    reason: finalReason,
    subscriptionend: loginData.renewaldate,
  };

  try {
    const response = await fetchCancelSubcriptionApi(data);

    if (response.success) {
      try {
        const response = await fetchSubscriptionLoginUserApi(
          loginData.username,
          loginData.password
        );

        if (response.statuscode === 200) {
          sessionStorage.setItem("loginData", JSON.stringify(response.data));
          const token = response.data.token;

          sessionStorage.setItem("tokenId", token);
          sessionStorage.setItem("subscriptionid", response.data.subscriptionid);
          sessionStorage.setItem("subscriptionStatus", response.data.status);
          sessionStorage.setItem("usertypeid", response.data.usertypeid);
          sessionStorage.setItem("username", response.data.username);
          sessionStorage.setItem("subscriberid", response.data.userid);

          setShowCancelPopup(false);
          setCancelMessage(
            `You’ll keep Pro access until ${convertUTCToLocalFormatted(
              loginData.renewaldate
            )}, then you’ll move to the Free plan.`
          );

          // // Navigate first
          // navigate("/account");

          // Then reload page after small delay
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else if (response.statuscode === 404) {
          setError(response.message);
        } else {
          setError("Invalid email or password");
        }
      } catch (err) {
        console.error("Login error:", err);
        setError("Something went wrong. Please try again.");
      }
    } else {
      setCancelMessage("Failed to cancel subscription. Please try again.");
    }
  } catch (err) {
    console.error("Error cancelling subscription:", err);
    setCancelMessage("Failed to cancel subscription. Please try again.");
  }
};




  return (
    <div className="account-container">
      {cancelMessage && (
        <p className="success-text">
          ✅ {cancelMessage}
        </p>
      )}
      <div className="plans">
        {/* Login Details */}
        <div className="plan free-plan">
          <div className="plan-header">
            <h3>Login Details</h3>
          </div>
          <div className="login-details">
            <div className="login-row">
              <div className="login-label">Email:</div>
              <div className="login-value">{loginData.username}</div>
            </div>
            <div className="login-row">
              <div className="login-label">Password:</div>
              <div className="login-value">
                {loginData.password ? "*".repeat(loginData.password.length) : ""}
              </div>
            </div>
            <button className="edit-btn" onClick={handleEditClick}>
              Edit Login Details
            </button>
          </div>
        </div>

        {/* Personal Details */}
        <div className="plan free-plan">
          <div className="plan-header">
            <h3>Personal Details</h3>
          </div>
          <div className="login-details">
            <div className="login-row">
              <div className="login-label">Name:</div>
              <div className="login-value">{loginData.firstname}</div>
            </div>
            <div className="login-row">
              <div className="login-label">Country:</div>
              <div className="login-value">{loginData.country || "Not set"}</div>
            </div>
            <button className="edit-btn" onClick={handleEditClickPersonal}>
              Edit Personal Details
            </button>
          </div>
        </div>

        {/* Product Details */}
        <div className="plan free-plan">
          <div className="plan-header">
            <h3>Product Details</h3>
          </div>
          <div className="login-details">
            <div className="login-row">
              <div className="login-label">Your Product:</div>
              <div className="login-value">
                {loginData.product ? loginData.product : <span style={{textAlign:'center', fontSize:'20px'}}>-</span>}
              </div>
            </div>

            {loginData.product === "Pro" && (
              <>
                {/* Subscription Type */}
                <div className="login-row">
                  <div className="login-label">Subscription Type:</div>
                  <div className="login-value">
                    {loginData.subscription ? loginData.subscription : "-"}
                  </div>
                </div>

                {/* Trial End Date */}
                {loginData.trialenddate && (
                  <div className="login-row">
                    <div className="login-label">Trial End Date:</div>
                    <div className="login-value">{convertUTCToLocalFormatted(loginData.trialenddate)}</div>
                  </div>
                )}

                {/* Subscription Start Date */}
                <div className="login-row">
                  <div className="login-label">Subscription Start Date:</div>
                  <div className="login-value">
                    {loginData.trialenddate
                      ? convertUTCToLocalFormatted(loginData.subscriptionstartdate)
                      : convertUTCToLocalFormatted(loginData.subscriptionstartdate) || "-"}
                  </div>
                </div>

                {/* Subscription End Date */}
                {loginData.subscriptionenddate && (
                  <div className="login-row">
                    <div className="login-label">Subscription End Date:</div>
                    <div className="login-value">{convertUTCToLocalFormatted(loginData.subscriptionenddate)}</div>
                  </div>
                )} 
              </>
            )}
            
          </div>
          {loginData.product === "Pro" && (
          loginData.paypalsubscriptionid && loginData.subscriptionstatus !== 'Cancelled' && (
            <>
            <div className="login-row">
              <div className="login-label-cancel">Increase your Subscription period:</div>
              <button className="upgrade-btn" onClick={() => navigate("/pricing")}>Upgrade</button>
            </div>
            <div className="login-row">
              <div className="login-label-cancel">Would you like to cancel your subscriptions? :</div>
              <button className="cancel-btn" onClick={handleCancelClick}>Cancel</button>
            </div>
            </>
          ))}

        </div>

      </div>

      {/* Login Edit Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button className="close-btn" onClick={handleClose}>
              ✖
            </button>
            <h2>Edit Login Details</h2>
            {error && <p className="error-text-paypal">{error}</p>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email:</label>
                <input type="text" name="email" value={formData.email} onChange={handleChange} />
              </div>
              {fieldError && (
                <p className="field-error-upgradelogin">{fieldError}</p>
              )}
              <div className="form-group">
                <label style={{ textAlign: "left" }}>Password</label>
                  <div className="password-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                    <span
                      className="password-toggle"
                      onClick={() => setShowPassword((prev) => !prev)}
                  >
                      {showPassword ? "Hide" : "Show"}
                  </span>
                  </div>
              </div>

              <button type="submit" className="save-btn">
                Save
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Personal Edit Popup */}
      {showPopupPersonal && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button className="close-btn" onClick={handleClosePersonal}>
              ✖
            </button>
            <h2>Edit Personal Details</h2>
            <form onSubmit={handleSubmitPersonal}>
              <div className="form-group">
                <label>Name:</label>
                <input
                  type="text"
                  name="firstname"
                  value={formDataPersonal.firstname}
                  onChange={handleChangePersonal}
                />
              </div>
              <div className="form-group">
                <label>Country:</label>
                  <select
                    name="country"
                    value={formDataPersonal.country}
                    onChange={handleChangePersonal}
                  >
                    <option value="">Select your country</option>
                    {countries.map((c, idx) => (
                      <option key={idx} value={c.country}>
                        {c.country}
                      </option>
                    ))}
                  </select>
              </div>
              <button type="submit" className="save-btn">
                Save
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Cancel Subscription Popup */}
      {showCancelPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button className="close-btn" onClick={handleCloseCancel}>
              ✖
            </button>
            <h2>Cancel Pro subscription?</h2>
            <p style={{fontSize:'14px'}}>You’ll keep Pro access until {convertUTCToLocalFormatted(loginData.renewaldate)}. After that, your account will revert to the Free plan.</p>
            <form onSubmit={handleCancelSubmit}>
              <div className="form-group">
                <label style={{fontSize:'14px'}}>Help us improve (optional):</label>
                <select
                  value={cancelReason}
                  onChange={(e) => setCancelReason(e.target.value)}
                  style={{ width: "100%", padding: "9px" }}
                >
                  <option style={{ fontSize: "14px" }} value="">Select a reason</option>
                  <option style={{ fontSize: "14px" }} value="Too expensive">Too expensive</option>
                  <option style={{ fontSize: "14px" }} value="Not using it enough">Not using it enough</option>
                  <option style={{ fontSize: "14px" }} value="Missing features">Missing features</option>
                  <option style={{ fontSize: "14px" }} value="Technical issues">Technical issues</option>
                  <option style={{ fontSize: "14px" }} value="Other">Other</option>
                </select>
              </div>

              {cancelReason === "Other" && (
                <div className="form-group" style={{ marginTop: "10px" }}>
                  <label>Please specify:</label>
                  <input
                    type="text"
                    value={otherReason}
                    onChange={(e) => setOtherReason(e.target.value)}
                    placeholder="Enter your reason here..."
                    style={{ width: "100%" }}
                  />
                </div>
              )}

              <button type="submit" className="save-btn" style={{fontSize:'14px'}}>
                Confirm cancellation 
              </button>
            </form>
          </div>
        </div>
      )}

      {showPopupSignup && (
        <SignupPopup
          showPopup={showPopupSignup} 
          handleClose={handleCloseSignup}
          setToken={setToken}
          hederLogin={true}
          disableClosebtn={true}
        />
      )}

    </div>
  );
}
